let requestBody: URLSearchParams;

export const getRequestBody = () => {
  if (!requestBody) {
    const htmlElement = document.documentElement;
    const rawRequestBody = htmlElement.dataset.requestbody ?? '';
    requestBody = new URLSearchParams(rawRequestBody);
  }

  const getRequestBodyAsString = (key: string): string => {
    const value = requestBody.get(key);
    if (!value) {
      throw new Error(`${key} is null`);
    }

    return value.toString();
  };

  return {
    requestBody: requestBody,
    accessToken: getRequestBodyAsString('access_token'),
    agreementId: getRequestBodyAsString('agreement_id'),
    replyUri: getRequestBodyAsString('reply_uri'),
    idTokenHint: getRequestBodyAsString('id_token_hint'),
    recordDeviceId:
      JSON.parse(getRequestBodyAsString('claims'))['id_token']['governance_control_state_per_device'] !== undefined,
  };
};
